let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("793gC")).then(() => parcelRequire('lXlqf'));